import { reactive } from 'vue';

export const criarEpProc = () => {
    return reactive({
        id: 0,
        idep: 0,
        idepmenuproc: 0,
        cdprocesso: '',
        nmprocesso: '',
        descricao: '',
        cksim: 'N',
        ckestabelecimento: 'N',
        ckproduto: 'N',
        ckrotulo: 'N',
        ativo: 'S',
        idlogin: 0,
    })
}
